/**
 * Component Registry for Repli Sandbox Theme
 *
 * Extends the base avneue-no-vendor theme registry with Repli Sandbox specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avneue-no-vendor/registry';
import { Hero } from './components/Hero';
import { FeaturedAmenities } from './components/FeaturedAmenities';
import { AmenityCardGrid } from './components/AmenityCardGrid';
import { Gallery } from './components/Gallery';
import { PetPolicy } from './components/PetPolicy';
import { PropertyOverview } from './components/PropertyOverview';
import { CTASection } from './components/CTASection';

/**
 * Repli Sandbox specific component overrides.
 * These components have been customized for the Repli Sandbox brand.
 */
const replisandboxOverrides: Partial<ComponentRegistry> = {
  Hero,
  FeaturedAmenities,
  AmenityCardGrid,
  Gallery,
  PetPolicy,
  PropertyOverview,
  CTASection,
};

/**
 * Final merged registry for Repli Sandbox properties.
 * Inherits all components from the avneue-no-vendor theme, with Repli Sandbox overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...replisandboxOverrides,
};

export default registry;
